import React, { useState, useEffect } from "react";
import axios from "axios";
import LeadDbService from "../../Services/LeadDbService";
import { getIcons } from "../../Constant/Constant";

const LeadDeals = ({ docId }) => {
  const icons = getIcons();
  const [activeTab, setActiveTab] = useState("On Going");
  const [deals, setDeals] = useState({
    ongoingDeals: [],
    completedDeals: [],
    lostDeals: [],
  });
  useEffect(() => {
    LeadDbService.fetchDealsByLeadId(docId)
      .then((response) => {
        setDeals(response.data);
        console.log("Deals fetched:", response.data);
      })
      .catch((error) => {
        console.error("There was an error fetching the deals!", error);
      });
  }, [docId]);

  const NoDealsVector = ({ type }) => {
    const getIllustration = () => {
      switch (type) {
        case "ongoing":
          return (
            <svg viewBox="0 0 200 150" className="w-32 h-24 mx-auto mb-4">
              <defs>
                <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#3B82F6" stopOpacity="0.2" />
                  <stop offset="100%" stopColor="#1D4ED8" stopOpacity="0.1" />
                </linearGradient>
              </defs>

              <circle
                cx="100"
                cy="75"
                r="35"
                fill="url(#grad1)"
                stroke="#3B82F6"
                strokeWidth="2"
              />
              <path
                d="M100 50 L100 75 L115 90"
                stroke="#3B82F6"
                strokeWidth="3"
                fill="none"
                strokeLinecap="round"
              />
              <circle cx="100" cy="75" r="3" fill="#3B82F6" />

              <circle cx="60" cy="40" r="3" fill="#93C5FD" opacity="0.6" />
              <circle cx="140" cy="45" r="2" fill="#60A5FA" opacity="0.4" />
              <circle cx="160" cy="110" r="2.5" fill="#3B82F6" opacity="0.3" />
            </svg>
          );
        case "completed":
          return (
            <svg viewBox="0 0 200 150" className="w-32 h-24 mx-auto mb-4">
              <defs>
                <linearGradient id="grad2" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#10B981" stopOpacity="0.2" />
                  <stop offset="100%" stopColor="#059669" stopOpacity="0.1" />
                </linearGradient>
              </defs>
              {/* Trophy illustration */}
              <path
                d="M70 60 Q70 45 85 45 L115 45 Q130 45 130 60 L130 80 Q130 95 115 95 L85 95 Q70 95 70 80 Z"
                fill="url(#grad2)"
                stroke="#10B981"
                strokeWidth="2"
              />
              <rect
                x="95"
                y="95"
                width="10"
                height="15"
                fill="#10B981"
                opacity="0.7"
              />
              <rect
                x="85"
                y="110"
                width="30"
                height="8"
                rx="4"
                fill="#10B981"
                opacity="0.5"
              />
              {/* Stars */}
              <path
                d="M50 50 L52 56 L58 56 L53 60 L55 66 L50 62 L45 66 L47 60 L42 56 L48 56 Z"
                fill="#34D399"
                opacity="0.6"
              />
              <path
                d="M150 35 L151.5 39 L155.5 39 L152.25 41.5 L153.75 45.5 L150 42.75 L146.25 45.5 L147.75 41.5 L144.5 39 L148.5 39 Z"
                fill="#10B981"
                opacity="0.4"
              />
            </svg>
          );
        case "lost":
          return (
            <svg viewBox="0 0 200 150" className="w-32 h-24 mx-auto mb-4">
              <defs>
                <linearGradient id="grad3" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#EF4444" stopOpacity="0.2" />
                  <stop offset="100%" stopColor="#DC2626" stopOpacity="0.1" />
                </linearGradient>
              </defs>
              {/* Document with X illustration */}
              <rect
                x="75"
                y="40"
                width="50"
                height="65"
                rx="5"
                fill="url(#grad3)"
                stroke="#EF4444"
                strokeWidth="2"
              />
              <path
                d="M90 65 L110 85 M110 65 L90 85"
                stroke="#EF4444"
                strokeWidth="3"
                strokeLinecap="round"
              />
              {/* Floating elements */}
              <circle cx="55" cy="60" r="2" fill="#F87171" opacity="0.5" />
              <circle cx="145" cy="70" r="1.5" fill="#EF4444" opacity="0.4" />
              <circle cx="160" cy="45" r="2" fill="#DC2626" opacity="0.3" />
            </svg>
          );
        default:
          return null;
      }
    };

    return (
      <div className="flex flex-col items-center justify-center py-3">
        {getIllustration()}
        <p className="text-gray-500 text-sm font-medium">
          {type === "ongoing" && "No on going deals yet"}
          {type === "completed" && "No completed deals"}
          {type === "lost" && "No lost deals"}
        </p>
        <p className="text-gray-400 text-xs mt-1">
          {type === "ongoing" && "New deals will appear here"}
          {type === "completed" && "Successful deals will show here"}
          {type === "lost" && "Lost opportunities will be listed here"}
        </p>
      </div>
    );
  };



  const tabs = ["On Going", "Completed", "Lost"];

  return (
    <div className="bg-white shadow-md rounded w-full h-96  ">
      <div className="p-4">
        <div className="bg-slate-100 p-2 mb-4 rounded-[10px] ">
          <div className="text-customGreen text-xl font-semibold">
            Lead Deals
          </div>
        </div>
        <div className="flex  border-gray-300 border-2 px-3 w-full text-lg rounded-md justify-between ">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`py-2 px-4 ${
                activeTab === tab
                  ? "border-b-2 border-custom-dark-green h-10 font-bold whitespace-nowrap text-custom-dark-green"
                  : "text-gray-500"
              }`}
            >
              {tab} (
              {deals[`${tab.replace(" ", "").toLowerCase()}Deals`]
                ? deals[`${tab.replace(" ", "").toLowerCase()}Deals`].length
                : 0}
              )
            </button>
          ))}
        </div>

        <div className="flex flex-col h-[225px]  mt-4 w-full items-center overflow-y-auto custom-scrollbar">
          {activeTab === "On Going" &&
            (deals.ongoingDeals && deals.ongoingDeals.length > 0 ? (
              deals.ongoingDeals.map((deal) => (
                <div
                  key={deal.id}
                  className="border rounded-lg w-5/6 4xl:m-10  p-4 shadow-md mb-4 "
                >
                  <h2 className="text-xl font-bold mb-2">
                    {deal.squareFeet} Sq Feet
                    <span className="text-gray-400 font-light text-lg">
                      {" "}
                      Approx
                    </span>
                  </h2>
                  <div className="flex items-center mb-2">
                    <div className="w-8 h-8 flex items-center justify-center text-white mr-2">
                      <img
                        className="w-5"
                        src={icons.pipelineUserIcon}
                        alt="User"
                      />
                    </div>
                    <span>{deal?.lead?.name}</span>
                  </div>
                  <div className="bg-blue-50 p-2 rounded-lg flex justify-between items-center">
                    <div>
                      <p className="font-bold">{deal?.property?.name}</p>
                      <p className="text-gray-500">
                        {deal?.currentStage?.name}
                      </p>
                    </div>
                    <div>
                      <p className="font-bold">
                        {deal?.dealFollowup?.responsible?.name}
                      </p>
                      <p className="text-gray-500">{deal?.team?.name}</p>
                    </div>
                    <div>
                      <p className="font-bold">On Going</p>
                      {/* <p className="font-bold">{dateTimeConversion(deal?.dealFollowup?.scheduledTime)}</p> */}
                      {/* <p className="text-gray-500">
                        {new Date(
                          deal?.dealFollowup?.scheduledTime
                        ).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </p> */}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="">
                <NoDealsVector type={"ongoing"} />
              </div>
            ))}

          {activeTab === "Completed" &&
            (deals.completedDeals && deals.completedDeals.length > 0 ? (
              deals.completedDeals.map((deal) => (
                <div
                  key={deal.id}
                  className="border rounded-lg w-5/6 p-4 shadow-md mb-4 "
                >
                  <h2 className="text-xl font-bold mb-2">
                    {deal.squareFeet} Sq Feet{" "}
                    <span className="text-gray-400">Fixed</span>
                  </h2>
                  <div className="flex items-center mb-2">
                    <div className="w-8 h-8 flex items-center justify-center text-white mr-2">
                      <img
                        className="w-5"
                        src={icons.pipelineUserIcon}
                        alt="User"
                      />
                    </div>
                    <span>{deal?.lead?.name}</span>
                  </div>
                  <div className="bg-blue-50 p-2 rounded-lg flex justify-between items-center">
                    <div>
                      <p className="font-bold">{deal?.property?.name}</p>
                      <p className="text-gray-500">
                        {deal?.currentStage?.name}
                      </p>
                    </div>
                    <div>
                      <p className="font-bold">
                        {deal.dealFollowup?.responsible?.name}
                      </p>
                      <p className="text-gray-500">{deal?.team?.name}</p>
                    </div>
                    <div>
                      <p className="font-bold">Completed</p>
                      {/* <p className="text-gray-500">
                        {new Date(
                          deal.dealFollowup.completedTime
                        ).toLocaleDateString()}
                      </p> */}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="">
                <NoDealsVector type={activeTab.toLocaleLowerCase()} />
              </div>
            ))}

          {activeTab === "Lost" &&
            (deals.lostDeals && deals.lostDeals.length > 0 ? (
              deals.lostDeals.map((deal) => (
                <div
                  key={deal.id}
                  className="border rounded-lg w-5/6 p-4 shadow-md mb-4"
                >
                  <h2 className="text-xl font-bold mb-2">
                    {deal.squareFeet} Sq Feet{" "}
                    <span className="text-gray-400"></span>
                  </h2>
                  <div className="flex items-center mb-2">
                    <div className="w-8 h-8 flex items-center justify-center text-white mr-2">
                      <img
                        className="w-5"
                        src={icons.pipelineUserIcon}
                        alt="User"
                      />
                    </div>
                    <span>{deal.lead?.name}</span>
                  </div>
                  <div className="bg-blue-50 p-2 rounded-lg flex justify-between items-center">
                    <div>
                      <p className="font-bold">{deal.property?.name}</p>
                      <p className="text-gray-500">{deal.currentStage?.name}</p>
                    </div>
                    <div className="truncate">
                      <p className="font-bold text-ellipsis">
                        {deal.dealFollowup.responsible?.name}
                      </p>
                      <p className="text-gray-500">{deal.team?.name}</p>
                    </div>
                    <div>
                      <p className="font-bold">Deal Lost</p>
                      {/* <p className="text-gray-500">
                        {new Date(
                          deal.dealFollowup.lostTime
                        ).toLocaleDateString()}
                      </p> */}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="">
                <NoDealsVector type={activeTab.toLocaleLowerCase()} />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default LeadDeals;
